import { Injectable } from '@angular/core';
import { LoadOptions } from 'devextreme/data';
import { ApiService } from '../../../core/api.service';
import { StockMoveDocumentLinesService } from '../../stock-move-documents/stock-move-document-lines/stock-move-document-lines.service';
import { StockMoveIncomingLine } from './stock-move-incoming-line.model';

@Injectable({
  providedIn: 'root'
})
export class StockMoveIncomingLinesService extends StockMoveDocumentLinesService<StockMoveIncomingLine> {
  public override url: string = 'StockMoveIncomingLine';
  public override documentType: string = 'StockMoveIncoming';
  public override defaultOptions: LoadOptions = {
    expand: ['Discount', 'ParentId']
  };

  constructor(public override api: ApiService) {
    super(api);
  }

  public override async getInstance(incoming?: Partial<StockMoveIncomingLine>): Promise<any> {
    let element = {
      ...incoming,
    };
    return element;
  }

  public async updateParentId(StockMoveIncomingLine: StockMoveIncomingLine, targetParentId: number) {
    return await this.api.sendRequest('/api/StockMoveDocumentLine/' + StockMoveIncomingLine.Id + '/changeParent/' + targetParentId, 'POST');
  }
}
